const imageSlider = function() {

    const defaults = {
        selectors: {
            container: ".imageSlider",
            item: ".imageSlider-item",
        }
    };

    const data = {};

    const init = function () {

        const containers = document.querySelectorAll(defaults.selectors.container);

        for (let i = 0; i < containers.length; i++) {
            new ImageSlider(containers[i]);
        }

    }

    const ImageSlider = function(container) {

        const self = this;

        this.settings = {
            durations: {
                browse: 500,
            },
        }

        this.properties = {
            isActive: false,
            isFocused: false,
        }

        this.data = {
            properties: this.properties,
            items: [],
            currentSlideIndex: 0,
            durations: this.settings.durations,
        };

            // Get items

        const items = container.querySelectorAll(defaults.selectors.item);

        for (let i = 0; i < items.length; i++) {

            const item = {
                container: items[i],
            }

            this.data.items.push(item);

        }

        // Init vue

        this.vue = new Vue({
            el: container,
            data: this.data,
            methods: {
                browse: (index) => { this.browse(index) },
            },
        });

        this.container = this.vue.$el;

            // Setup event for resetting slideshows

        document.addEventListener(
            'imageSlider:reset',
            (event) => {
                self.properties.isFocused = false;
                self.browse(0);
            },
            false
        );

            // Setup event for focusing this slideshow or blur all

        this.container.addEventListener(
            'imageSlider:focus',
            (event) => {
                self.properties.isFocused = true;
            },
            false
        );

            // Setup event for blurring slideshows

        document.addEventListener(
            'imageSlider:blur',
            (event) => {
                self.properties.isFocused = false;
            },
            false
        );

            // Add keyboard controls (only active if slideshow is focused)

        document.addEventListener('keydown', function(e) {

            if (! self.properties.isFocused) {
                return true;
            }

            let prevent_default = false;

            if ([33, 36, 37, 38].indexOf(e.keyCode) !== -1) {
                prevent_default = true;
                self.browse(self.data.currentSlideIndex - 1);
            }

            if ([34, 35, 39, 40].indexOf(e.keyCode) !== -1) {
                prevent_default = true;
                self.browse(self.data.currentSlideIndex + 1);
            }

            if (prevent_default) {
                e.preventDefault();
            }

        });

            // Activate

        this.activate();

    }

    ImageSlider.prototype.activate = function(activate) {

        this.properties.isActive = (typeof activate === "boolean") ? activate : true;

    }

    ImageSlider.prototype.browse = function(index) {

        var self = this;

        index = index || 0;

        if (index === this.data.currentSlideIndex) {
            return;
        }

        this.activate(false);

        setTimeout(
            () => {
                this.activate();
            },
            this.settings.durations.browse
        );

        let direction = index - this.data.currentSlideIndex,
            index_min = 0,
            index_max = this.data.items.length - 1;

        this.data.currentSlideIndex += direction;

        if (this.data.currentSlideIndex < index_min) {
            this.data.currentSlideIndex = index_min;
        }

        if (this.data.currentSlideIndex > index_max) {
            this.data.currentSlideIndex = index_max;
        }

    }

        /*****************************************/
        /******//* !Return public method *//******/
        /*****************************************/

    return {
        init: init,
        data: data,
    }

}();

imageSlider.init();
